import { Grid, CSSObject } from '@chakra-ui/react'
import { useTrail } from 'react-spring'
import { useInView } from 'react-intersection-observer'

import { AnimatedBox, DEFAULT_SPRING_CONFIG } from '@/lib/springComponent'

import WidgetItem from './WidgetItem'
import { WidgetProps } from '../../types'

interface Props {
  items: WidgetProps[]
  sx?: CSSObject
}

function WidgetItemList({ items, sx }: Props): React.ReactElement {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  })

  const springs = useTrail(items.length, {
    to: {
      transform: inView ? 'translate3d(0, 0px, 0)' : 'translate3d(0, 32px, 0)',
      opacity: inView ? 1 : 0,
    },
    config: DEFAULT_SPRING_CONFIG,
  })

  return (
    <Grid
      ref={ref}
      sx={{
        gridGap: { base: 6, sm: 8 },
        alignItems: 'stretch',
        justifyItems: 'center',
        gridTemplateColumns: {
          base: '1fr',
          sm: `repeat(${Math.min(items.length, 2)}, 1fr)`,
          ...(items.length > 2 ? { md: 'repeat(4, 1fr)' } : null),
        },
        ...sx,
      }}
    >
      {items.map((item, index) => (
        <AnimatedBox key={`${index}`} style={springs[index]}>
          <WidgetItem {...item} sx={{ h: 'full', ...item.sx }} />
        </AnimatedBox>
      ))}
    </Grid>
  )
}

export default WidgetItemList
